{
  "slug": "supervised-vs-unsupervised-iq-tests",
  "title": "Supervised vs Unsupervised IQ Tests",
  "description": "Compare supervised and unsupervised IQ testing, including standardization, identity, assistance, security, and appropriate uses.",
  "summary": "Supervision controls administration and documents who completed the assessment. Unsupervised testing is more convenient but leaves more uncertainty about conditions and score use.",
  "category": "Comparisons",
  "sections": [
    {
      "heading": "What supervision adds",
      "paragraphs": [
        "A trained or authorized administrator can standardize instructions, timing, materials, breaks, accommodations, identity, and observations. These controls support comparability and help explain unusual behavior or interruptions.",
        "Supervision does not make every test valid; the instrument and interpretation must also be suitable for the intended purpose."
      ]
    },
    {
      "heading": "Limits of unsupervised testing",
      "paragraphs": [
        "At home, the system cannot fully know whether another person helped, external tools were used, interruptions occurred, or the intended candidate completed the test. Device and environment also vary.",
        "Those limitations are acceptable for some low-stakes practice and self-exploration when they are disclosed, but they weaken high-stakes claims."
      ]
    },
    {
      "heading": "Match evidence to the decision",
      "paragraphs": [
        "Use an unsupervised result as an estimate, not a credential. Schools, clinicians, employers, courts, and membership organizations may require approved instruments, qualified administration, and verifiable reports.",
        "Ask the receiving organization what it accepts before paying for or scheduling any assessment."
      ]
    }
  ],
  "faqs": [
    {
      "question": "Does webcam monitoring make an online test supervised?",
      "answer": "It can add controls, but adequacy depends on the test, procedures, identity checks, privacy, and intended use."
    },
    {
      "question": "Can an unsupervised test be accurate?",
      "answer": "It can estimate performance under those conditions, but uncontrolled assistance and environment add uncertainty."
    }
  ],
  "related": ["how-to-take-an-iq-test", "iq-test-validity", "free-vs-paid-iq-tests"],
  "sources": [
    {
      "label": "International Test Commission — technology-based assessment guidelines",
      "url": "https://www.intestcom.org/page/16"
    },
    {
      "label": "International Test Commission — guidelines on test use",
      "url": "https://www.intestcom.org/page/15"
    },
    {
      "label": "Mensa International — getting your IQ tested",
      "url": "https://www.mensa.org/getting-your-iq-tested-faqs/"
    }
  ]
}
